import React from 'react';

const phrases = [
  'Interview prep at institution scale',
  'One console for your whole placement cell',
  'Add students. Allocate credits. Assign interviews.',
  'Track completion and performance in real time',
  'Powered by the prepxai interview engine',
];

const InstitutionTaglineMarquee = () => {
  const doubled = [...phrases, ...phrases];

  return (
    <section className="border-y border-[var(--lp-line)] bg-white py-5 overflow-hidden">
      <div className="lp-marquee flex w-max gap-12 whitespace-nowrap">
        {doubled.map((phrase, i) => (
          <span
            key={`${phrase}-${i}`}
            className="flex items-center gap-12 font-mono text-xs tracking-wider text-[var(--lp-ink-soft)]"
          >
            {phrase}
            <span className="h-1 w-1 rounded-full bg-[var(--lp-accent)]" />
          </span>
        ))}
      </div>
    </section>
  );
};

export default InstitutionTaglineMarquee;
